import React, { Component } from "react";
import Button from "../common/button/index";
import Plx from "react-plx";

// actions
import { subscribeUser, getBreweryHours } from "../../actions";

// assets
import dogs from "../../assets/svg/baileson-dogs.svg";
import instagram from "../../assets/svg/instagram.svg";
import facebook from "../../assets/svg/facebook.svg";
import twitter from "../../assets/svg/twitter.svg";
import untappd from "../../assets/svg/untappd.svg";
import badge from "../../assets/png/small_badge.png";

class Footer extends Component {
  state = {
    submitting: false,
    error: null,
    message: null,
    hours: null,
  };

  componentDidMount() {
    this.fetchHours();
  }

  fetchHours = async () => {
    try {
      const { hours } = await getBreweryHours();
      if (hours) {
        this.setState({ hours });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  submitForm = (e) => {
    e.preventDefault();

    this.setState({
      error: false,
      message: null,
      submitting: true,
    });

    const names = this.name.value.split(" ");

    subscribeUser({
      first: names[0],
      last: names[1],
      email: this.email.value,
    })
      .then((response) => {
        this.setState({
          error: false,
          submitting: false,
          submitted: true,
          message: `Awesome! We'll keep you updated on new brews and news.`,
        });
      })
      .catch((error) => {
        this.setState({
          error: true,
          submitting: false,
          submitted: false,
          message: "Hmmm, looks like something went wrong.",
        });
      });
  };

  render() {
    const { submitted, submitting, message, hours, error } = this.state,
      year = new Date(),
      footerConfig = [
        {
          start: `self`,
          end: `.taproom__details`,
          properties: [
            {
              startValue: 0,
              endValue: 1,
              property: "opacity",
            },
          ],
        },
      ],
      textConfig = [
        {
          start: `self`,
          end: `.site-footer__newsletter`,
          properties: [
            {
              startValue: 200,
              endValue: 0,
              property: `translateY`,
            },
          ],
        },
      ];

    return (
      <footer className="site-footer">
        <div className="site-footer__taproom">
          <Plx parallaxData={footerConfig}>
            <div className="taproom__bg" />
          </Plx>

          <div className="taproom__details">
            <div className="wrapper">
              <Plx parallaxData={textConfig}>
                <div className="taproom__details--title">
                  <h3 className="heading heading--super beige">
                    Taproom <br /> Details
                  </h3>
                </div>
              </Plx>

              <div className="taproom__details--hours">
                <div className="wrapper">
                  <h4 className="heading heading--small brown">Hours</h4>
                  {hours && <div dangerouslySetInnerHTML={{ __html: hours }} />}
                  <p>2322 Bissonnet St, Houston, TX 77005</p>
                  <div className="actions">
                    <div className="action-row">
                      <Button
                        type="outside"
                        action="https://goo.gl/maps/d5CjPiE8LDC2"
                        classes="white"
                      >
                        Directions
                      </Button>
                    </div>
                    <div className="action-row">
                      <Button
                        type="email"
                        action="beer@bailesonbrewing.com"
                        classes="white"
                      >
                        Contact
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="site-footer__newsletter">
            <div className="baileson-dogs">
              <img src={dogs} alt="baileson dogs icon" />
            </div>

            <div className="wrapper">
              <div className="form__title">
                <h5 className="heading heading--small brown">
                  The best kind of news is beer news
                </h5>
                <p>
                  Sign up to get notified with new beers and Baileson events
                </p>
              </div>

              {error && message && <p>{message}</p>}
              {!error && submitted && <p>{message}</p>}

              {!submitted && (
                <form>
                  <div className="form__inputs">
                    <div className="input">
                      <input
                        type="text"
                        id="name"
                        ref={(name) => (this.name = name)}
                      />
                      <label htmlFor="name">Name</label>
                    </div>
                    <div className="input">
                      <input
                        type="email"
                        id="email"
                        ref={(email) => (this.email = email)}
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                  </div>
                  <div className="form__submit">
                    <button
                      onClick={(e) => this.submitForm(e)}
                      className={`btn primary ${submitting && "disabled"}`}
                      type="submit"
                      id="submit"
                    >
                      {submitting ? "Submitting" : "Submit"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
        <div className="site-footer__bottom">
          <div className="bottom__badge">
            <img
              src={badge}
              alt="Baileson brand badge"
              width="185"
              height="144"
            />
          </div>
          <div className="bottom__social-links">
            <a
              className="link"
              href="https://www.facebook.com/bailesonbrewing/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img src={facebook} alt="facebook icon" height="30" width="30" />
            </a>
            <a
              className="link"
              href="https://twitter.com/bailesonbrewing"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img src={twitter} alt="twitter icon" height="30" width="30" />
            </a>
            <a
              className="link"
              href="https://www.instagram.com/bailesonbrewing/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src={instagram}
                alt="instagram icon"
                height="30"
                width="30"
              />
            </a>
            <a
              className="link"
              href="https://untappd.com/BailesonBrewingCo"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img src={untappd} alt="untappd icon" height="30" width="30" />
            </a>
          </div>
          <div className="bottom__colophon">
            <p>
              &copy;
              {year.getFullYear()} Baileson Brewing Co | Branded in HTX by{" "}
              <a href="https://circlefifty.com">Circlefifty Creative</a> |
              Developed by <a href="https://cmbdev.com">CMBDEV</a>
            </p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js